export const ENTRY_LOADING_STATUS = {
    DONE: 'done',
    LOADING: 'loading',
    UNAVAILABLE: 'unavailable',
    ERROR: 'error'
};

export const ENTRY_LOAD_ACTION = {
    PRINT: 'print'
};

export default () => {
    return {
        entries: {
            list: [],
            pagination: {
                index: 1,
                lastSequenceNumber: undefined,
                showLoadMoreButton: false,
                hasMore: true
            },
            loadingStatus: ENTRY_LOADING_STATUS.DONE,
            loadAction: undefined,
            dropdownData: {}
        },
        pending: undefined,
        payoutStatus: {},
        csvLoading: false,
        showPayoutFrequencyModal: false
    };
};
